import React from 'react'

export default function DashProjects() {
  return (
    <div className='bg-[#292c35] h-full text-white rounded-lg'>
        <h1>Projects Tab</h1>
    </div>
  )
}
